<template>
    <div id="app">
        <app-header></app-header>
        <router-view></router-view>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import firebase from 'firebase'
    import db from '@/components/db'
    import userData from '@/components/uid'
    import VueFire from 'vuefire'
    import { eventBus } from '@/main'
    
    export default {
        components: {
            appHeader: Header
        },
        name: 'app',
        mounted() {
            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    // User is signed in.
                    eventBus.$emit('loggedIn', true);
                } else {
                    // No user is signed in.
                    eventBus.$emit('loggedIn', false);
                }
            });
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }
</style>



// WEBPACK FOOTER //
// App.vue?11290d72